<template>
  <div>
    <!-- v-if="$store.state.userData.userId==params.data.userId" -->
    <feather-icon icon="DollarSignIcon" @click="newSale = true" title="Satış Yap" svgClasses="h-5 w-5 mr-5  hover:text-danger cursor-pointer" />
    <feather-icon icon="Edit3Icon" @click="OpenActivationForm()" title="Düzenleme" svgClasses="h-5 w-5 mr-5 hover:text-primary cursor-pointer" />
    <feather-icon icon="Trash2Icon" @click="visible = true" title="Silme" svgClasses="h-5 w-5 mr-5  hover:text-danger cursor-pointer" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '24') != null" />
    <vs-prompt
      vs-title="Abonelik Sil"
      vs-button-cancel="border"
      vs-cancel-text="Vazgeç"
      vs-accept-text="Sil"
      @vs-close="cancel"
      @vs-cancel="cancel"
      @vs-accept="DeleteSubscription(params.data.activationFormId)"
      vs-color="danger"
      :vs-active.sync="visible"
    >
      <div class="vx-row ml-5 mr-5">
        <p>{{ params.data.activationFormId }} numaralı aboneliği silmek istiyor musunuz ?</p>
      </div>
    </vs-prompt>
    <vs-prompt vs-title="Satış Yap" vs-button-cancel="border" vs-cancel-text="Vazgeç" vs-accept-text="Kaydet" @vs-close="cancel" @vs-cancel="cancel" @vs-accept="SaveSale(params.data.activationFormId)" vs-color="danger" :vs-active.sync="newSale">
      <div class="vx-row ml-5 mr-5">
        <p>{{ params.data.activationFormId }} numaralı aboneliği satış teklifine düşürmek istiyor musunuz ?</p>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
export default {
  data() {
    return {
      subscriptionPopup: false,
      visible: false,
      newSale: false,
      products: [],
    };
  },
  name: "CellRendererActions",
  computed: {
    getDate() {
      let d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().substr(0, 16);
    },
  },
  methods: {
    OpenActivationForm() {
      this.params.context.componentParent.subscriptionPopup = true;
      this.params.context.componentParent.subscriptionItem = this.params.data;
    },
    DeleteSubscription: async function (activationFormId) {
      let r = await repository.deleteWithParam("Subscription/DeleteSubscription?activationFormId", activationFormId);

      if (r && r.isSuccessful) {
        await this.$swal.fire(`"${this.params.data.activationFormId}" Başarıyla Silindi.`);
        this.params.context.componentParent.getSubscriptionSystem();
      } else {
        this.$vs.notify({
          color: "danger",
          icon: "warning",
          title: "Hata!",
          text: `"${this.params.data.activationFormId}" silme işlemi tamamlanamadı`,
        });
      }
    },
    SaveSale: async function (activationFormId) {
      if (activationFormId > 0) {
        let data = this.params.data;
        let arrangementDate = this.getDate;
        let validityDate = new Date(new Date(arrangementDate).getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 16);

        if (data.productId) {
          this.products.push({
            productId: data.productId,
            productAmount: 1,
            discount: 0,
            discountPercent: 0,
            price: data.salePrice,
            priceId: 3,
            priceDiscounted: data.salePrice,
            lineType: 1,
            wareHouseId: 30,
          });
        }
        let postModel = {
          status: 1,
          deleted: 0,
          createdUserId: data.userId,
          customerId: data.customerId,
          saleOrderType: 0,
          saleOrderStatus: 0,
          saleOrderNote: data.description,
          createdDate: arrangementDate,
          validUntil: validityDate,
          price: 1,
          priceDiscounted: data.salePrice,
          discount: data.salePrice,
          discountPercent: 0,
          deliveryAddress: data.address,
          paymentType: 3,
          deliveryType: 2,
          currency: data.salePriceCurrencyId,
          taxIncluded: 0,
          isSent: 0,
          isFullInvoice: 0,
          OrderLines: this.products,
        };

        let r = await repository.postEntity("Subscription/SaveSaleSubscription", postModel);
        if (r && r.isSuccessful) {
          await this.$swal.fire(`"${this.params.data.activationFormId}" satış teklifine dönüşmüştür.`);
          this.$router.push("/Sales").catch((err) => {});
          
        } else {
          this.$vs.notify({
            color: "danger",
            icon: "warning",
            title: "Hata!",
            text: `"${this.params.data.activationFormId}" satış teklifine dönüşemedi`,
          });
        }
      }
    },

    cancel() {
      this.visible = false;
    },
  },
};
</script>
